<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    @if (poolAdditionalData?.networkConnexion === 1) {
      <app-header-configuration
        [title]="'P00045.installation.link.signalwifi.title' | translate"
        [description]="
          'P00045.installation.link.signalwifi.description' | translate
        "
      >
      </app-header-configuration>

      <div>
        @if (
          actionStack!.getValue('cnSEtatConnexionWifi') === 0 &&
          actionStack!.getValue('cnSEtatProcessusWifi') === 1
        ) {
          <div>
            <div>
              <div style="height: 150px">
                <div class="row h-100">
                  <div class="col text-center">
                    <ion-spinner name="circular"></ion-spinner>
                  </div>
                </div>
              </div>
              <div class="text-center mt-2">
                {{
                  getTextFromValueWifi(
                    actionStack!.getValue('cnSEtatConnexionWifi'),
                    actionStack!.getValue('cnSEtatProcessusWifi'),
                    actionStack!.getValue('cnSRSSIWifi')
                  ) | translate
                }}
              </div>
            </div>
          </div>
        } @else {
          <div>
            <div>
              <img
                [src]="
                  getImageFromValueWifi(
                    actionStack!.getValue('cnSEtatConnexionWifi'),
                    actionStack!.getValue('cnSEtatProcessusWifi'),
                    actionStack!.getValue('cnSRSSIWifi')
                  )
                "
                alt="wifi-signal-check.png"
                style="width: 100%; height: 150px; object-fit: contain"
              />
              <div class="text-center mt-2">
                {{
                  getTextFromValueWifi(
                    actionStack!.getValue('cnSEtatConnexionWifi'),
                    actionStack!.getValue('cnSEtatProcessusWifi'),
                    actionStack!.getValue('cnSRSSIWifi')
                  ) | translate
                }}
              </div>
            </div>
          </div>
        }
      </div>
    }

    <app-header-configuration
      [title]="'P00045.installation.link.signalradio' | translate"
      [description]="
        'P00045.installation.link.signalradio.description' | translate
      "
    >
    </app-header-configuration>

    <div>
      <div
        style="
          background-color: var(--ion-color-primary-tint);
          border-radius: 10px;
        "
      >
        <div class="row px-3 py-2 align-items-center">
          <div class="col-auto">
            <i class="fa-solid fa-info-circle color-orange"></i>
          </div>
          <div class="col fs-12 color-orange">
            {{ 'P00045.installation.link.signalradio.warning' | translate }}
          </div>
        </div>
      </div>

      <div>
        <div>
          <img
            [src]="getImageFromValueZB()"
            alt="wifi-signal-check.png"
            style="width: 100%; height: 150px; object-fit: contain"
          />
          <div class="text-center mt-2">
            {{ getTextFromValueZB() | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
